import "./Spinner.css"
import { memo } from "react"

const Spinner = () => {
  return (
    <div className="loader"></div>
  )
}

export default memo(Spinner)